/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ aligned: NonNullable<unknown>, differences: NonNullable<unknown> }} Compare_Event_Groups_SummaryInputs */

const en_compare_event_groups_summary = /** @type {(inputs: Compare_Event_Groups_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.aligned} aligned events (${i?.differences} differences)`)
};

const fr_compare_event_groups_summary = /** @type {(inputs: Compare_Event_Groups_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.aligned} événements alignés (${i?.differences} différences)`)
};

const de_compare_event_groups_summary = /** @type {(inputs: Compare_Event_Groups_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.aligned} ausgerichtete Ereignisse (${i?.differences} Unterschiede)`)
};

const it_compare_event_groups_summary = /** @type {(inputs: Compare_Event_Groups_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.aligned} eventi allineati (${i?.differences} differenze)`)
};

const ru_compare_event_groups_summary = /** @type {(inputs: Compare_Event_Groups_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`События, выровненные по ${i?.aligned} (различия по ${i?.differences})`)
};

const es_compare_event_groups_summary = /** @type {(inputs: Compare_Event_Groups_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.aligned} eventos alineados (${i?.differences} diferencias)`)
};

const zh_cn2_compare_event_groups_summary = /** @type {(inputs: Compare_Event_Groups_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.aligned} 对齐事件（${i?.differences} 差异）`)
};

const ja_compare_event_groups_summary = /** @type {(inputs: Compare_Event_Groups_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.aligned} 個の整列イベント (${i?.differences} 個の差異)`)
};

const hi_compare_event_groups_summary = /** @type {(inputs: Compare_Event_Groups_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.aligned} संरेखित घटनाएँ (${i?.differences} अंतर)`)
};

const pt_pt2_compare_event_groups_summary = /** @type {(inputs: Compare_Event_Groups_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eventos alinhados ${i?.aligned} (diferenças ${i?.differences})`)
};

/**
* | output |
* | --- |
* | "{aligned} aligned events ({differences} differences)" |
*
* @param {Compare_Event_Groups_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_summary = /** @type {((inputs: Compare_Event_Groups_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_summary(inputs)
	if (locale === "de") return de_compare_event_groups_summary(inputs)
	if (locale === "it") return it_compare_event_groups_summary(inputs)
	if (locale === "ru") return ru_compare_event_groups_summary(inputs)
	if (locale === "es") return es_compare_event_groups_summary(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_summary(inputs)
	if (locale === "ja") return ja_compare_event_groups_summary(inputs)
	if (locale === "hi") return hi_compare_event_groups_summary(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_summary(inputs)
	return en_compare_event_groups_summary(inputs)
});